import React from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import PropTypes from 'prop-types'
import BEM from '@iui-kit/utils/bem'
import { ErrorMessage } from 'formik'
import styles from './Textarea.css'

const bem = new BEM(styles)

const Textarea = ({
  children,
  name,
  label,
  handleBlur,
  onChange,
  size,
  isValid,
  className,
  placeholder,
  ...other
}) => (
  <>
    <label
      className={bem
        .b('TextareaLabel')
        .m('invalid', !isValid)
        .mix(className)
        .show()}
    >
      {label && (
        <span
          className={bem
            .b('TextareaLabel')
            .e('label')
            .show()}
        >
          <FormattedHTMLMessage id={label} />
        </span>
      )}
      <textarea
        {...other}
        name={name}
        className={bem
          .b('TextareaLabel')
          .e('input')
          .m(size)
          .mix(className)
          .show()}
        onChange={onChange}
        onBlur={handleBlur}
        placeholder={placeholder}
      >
        {children}
      </textarea>
    </label>
    <ErrorMessage
      className={bem
        .b('TextareaLabel')
        .e('error')
        .show()}
      component="div"
      name={name}
    />
  </>
)

Textarea.defaultProps = {
  size: 'm',
  className: null,
  children: null,
  label: null
}

Textarea.propTypes = {
  onChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  isValid: PropTypes.bool.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.oneOf(['s', 'm', 'l'])
}

export default Textarea
